import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  }
}));

export default function Progress(props) {
  const classes = useStyles();

  return (
    <div
      className={classes.root}
      style={!props.show ? { display: 'none' } : props.style}
    >
      <CircularProgress size={16 || props.size} />
    </div>
  );
}

Progress.propTypes = {
  show: PropTypes.bool,
  size: PropTypes.number,
  style: PropTypes.object
};
